










import { Component, Vue } from "vue-property-decorator";
import Files from "@/components/Files.vue";

@Component({
  components: {
    Files
  }
})
export default class FileListView extends Vue {}
